// deprecated - updating Redux via input/output actions is deprecated, use fetchInterceptor pattern instead

import {
  remoteLogin,
  remoteLogout,
  hostStoreConnect,
  wsOnMessage,
  setRouterPath,
  setUserError,
  setUserIsError,
  setUserPending,
  setUserSuccess,
  setUserData,
  updateAccountData,
  updateUser,
  addNotification,
  markNotification,
  setNotificationsError,
  setNotificationsList,
  setNotificationsPending,
  setNotificationsTotalCount,
  setNotificationsUnreadCount,
  resetNotificationsState,
  acceptAllFollowRequests,
  undoNotification,
  setInstanceInfo,
  setInstanceInfoPending,
  setInstanceInfoError,
  setPlatformSettings,
  setProfileSettings,
  setGroupData,
  setGroupLoading,
  setDeviceType,
  setDeviceWidth,
} from './remoteActions'

import {
  remoteReady,
  reselectUser,
  requestLogout,
  setConfirmLeavePage,
  requestChangePath,
  wsSubscribe,
  wsUnSubscribe,
  askLoginAction,
} from './hostActions'

export const inputActions = [
  requestChangePath,
  wsSubscribe,
  wsUnSubscribe,
  remoteReady,
  reselectUser,
  requestLogout,
  askLoginAction,
  setConfirmLeavePage,
  acceptAllFollowRequests,
]

export const outputActions = [
  remoteLogin,
  remoteLogout,
  hostStoreConnect,
  wsOnMessage,
  setRouterPath,
  setDeviceType,
  setDeviceWidth,
  setUserError,
  setUserIsError,
  setUserPending,
  setUserSuccess,
  setUserData,
  updateAccountData,
  updateUser,
  addNotification,
  markNotification,
  setNotificationsError,
  setNotificationsList,
  setNotificationsPending,
  setNotificationsTotalCount,
  setNotificationsUnreadCount,
  resetNotificationsState,
  undoNotification,
  setInstanceInfo,
  setInstanceInfoPending,
  setInstanceInfoError,
  setPlatformSettings,
  setProfileSettings,
  setGroupData,
  setGroupLoading,
]

if (
  outputActions.some((outputAction) =>
    inputActions.some(
      (inputAction) => inputAction?.toString() === outputAction?.toString(),
    ),
  )
) {
  throw new Error('Output action is duplicated with input action')
}
